import { Navigate, Route, Routes } from "react-router-dom";
import routes from "routes";

const PublicLayout = () => {
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/public") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div className="h-full">
      <div className="relative w-full dark:!bg-navy-900">
        <main className={`mx-auto`}>
          <div className="relative flex">
            <div className="mx-auto flex min-h-full w-full flex-col justify-start">
              <div className="mb-auto flex h-full flex-col">
                {
                  <Routes>
                    {getRoutes(routes)}
                    <Route
                      path="/"
                      element={<Navigate to="/auth/sign-in" replace />}
                    />
                  </Routes>
                }
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PublicLayout;
